const zoneA = {
	'0.5': 26560,
	'1.0': 28390,
	'1.5': 31160,
	'2.0': 33080,
	'2.5': 35000,
	'3.0': 36780,
	'3.5': 38570,
	'4.0': 40350,
	'4.5': 42140,
	'5.0': 43920,
	'5.5': 45480,
	'6.0': 46970,
	'6.5': 48450,
	'7.0': 49940,
	'7.5': 51420,
	'8.0': 52910,
	'8.5': 54390,
	'9.0': 55880,
	'9.5': 57360,
	'10.0': 58850,
	'10.5': 73640,
	'11.0': 75350,
	'11.5': 77070,
	'12.0': 78780,
	'12.5': 80500,
	'13.0': 82210,
	'13.5': 83920,
	'14.0': 85640,
	'14.5': 87350,
	'15.0': 89070,
	'15.5': 90780,
	'16.0': 92490,
	'16.5': 94210,
	'17.0': 95920,
	'17.5': 97640,
	'18.0': 99350,
	'18.5': 101070,
	'19.0': 102780,
	'19.5': 104490,
	'20.0': 106210,
	'20.5': 107920,
	'21.0': 112130,
	'21.5': 114950,
	'22.0': 117780,
	'22.5': 120600,
	'23.0': 123430,
	'23.5': 126250,
	'24.0': 129080,
	'24.5': 131900,
	'25.0': 134730,
	'25.5': 137560,
	'26.0': 140380,
	'26.5': 143210,
	'27.0': 146030,
	'27.5': 148860,
	'28.0': 151680,
	'28.5': 154510,
	'29.0': 157330,
	'29.5': 160160,
	'30.0': 162980,
	'30.5': 165810,
	'31.0': 168630,
	'31.5': 171460,
	'32.0': 174280,
	'32.5': 177110,
}

const zoneD = {
	'0.5': 37820,
	'1.0': 45900,
	'1.5': 49940,
	'2.0': 54810,
	'2.5': 59570,
	'3.0': 64260,
	'3.5': 68940,
	'4.0': 73630,
	'4.5': 78320,
	'5.0': 83000,
	'5.5': 83020,
	'6.0': 86710,
	'6.5': 90400,
	'7.0': 94090,
	'7.5': 97780,
	'8.0': 101470,
	'8.5': 105160,
	'9.0': 108820,
	'9.5': 112510,
	'10.0': 116200,
	'10.5': 135880,
	'11.0': 139110,
	'11.5': 142340,
	'12.0': 145570,
	'12.5': 148800,
	'13.0': 152030,
	'13.5': 155260,
	'14.0': 158490,
	'14.5': 161720,
	'15.0': 164950,
	'15.5': 168180,
	'16.0': 171410,
	'16.5': 174640,
	'17.0': 177870,
	'17.5': 181100,
	'18.0': 184330,
	'18.5': 187560,
	'19.0': 190790,
	'19.5': 194020,
	'20.0': 197250,
	'20.5': 200480,
	'21.0': 221570,
	'21.5': 227200,
	'22.0': 232840,
	'22.5': 238480,
	'23.0': 244110,
	'23.5': 249750,
	'24.0': 255390,
	'24.5': 261030,
	'25.0': 266660,
	'25.5': 272300,
	'26.0': 277940,
	'26.5': 283570,
	'27.0': 289210,
	'27.5': 294850,
	'28.0': 300480,
	'28.5': 306120,
	'29.0': 311760,
	'29.5': 317400,
	'30.0': 323030,
	'30.5': 328670,
	'31.0': 334310,
	'31.5': 339940,
	'32.0': 345580,
	'32.5': 351220,
}

const zoneE = {
	'0.5': 21020,
	'1.0': 24950,
	'1.5': 30470,
	'2.0': 33030,
	'2.5': 35470,
	'3.0': 37100,
	'3.5': 40050,
	'4.0': 43010,
	'4.5': 45960,
	'5.0': 48920,
	'5.5': 55060,
	'6.0': 58000,
	'6.5': 60950,
	'7.0': 63900,
	'7.5': 66850,
	'8.0': 69790,
	'8.5': 72740,
	'9.0': 81690,
	'9.5': 84870,
	'10.0': 88050,
	'10.5': 89790,
	'11.0': 103850,
	'11.5': 106480,
	'12.0': 109110,
	'12.5': 111730,
	'13.0': 114360,
	'13.5': 116990,
	'14.0': 119610,
	'14.5': 122240,
	'15.0': 124870,
	'15.5': 127490,
	'16.0': 130120,
	'16.5': 148530,
	'17.0': 151470,
	'17.5': 154410,
	'18.0': 157350,
	'18.5': 160290,
	'19.0': 163220,
	'19.5': 166160,
	'20.0': 169100,
	'20.5': 172040,
	'21.0': 201910,
	'21.5': 207120,
	'22.0': 212330,
	'22.5': 217550,
	'23.0': 222760,
	'23.5': 227970,
	'24.0': 233190,
	'24.5': 238400,
	'25.0': 243610,
	'25.5': 248830,
	'26.0': 254040,
	'26.5': 259260,
	'27.0': 264470,
	'27.5': 269680,
	'28.0': 274900,
	'28.5': 280110,
	'29.0': 285320,
	'29.5': 290540,
	'30.0': 295750,
	'30.5': 300970,
	'31.0': 306180,
	'31.5': 311390,
	'32.0': 316610,
	'32.5': 321820,
}

const zoneF = {
	'0.5': 20950,
	'1.0': 24810,
	'1.5': 30340,
	'2.0': 32800,
	'2.5': 35120,
	'3.0': 37080,
	'3.5': 40140,
	'4.0': 43190,
	'4.5': 46250,
	'5.0': 49310,
	'5.5': 55480,
	'6.0': 58390,
	'6.5': 61310,
	'7.0': 64220,
	'7.5': 67130,
	'8.0': 70050,
	'8.5': 72960,
	'9.0': 81430,
	'9.5': 84560,
	'10.0': 87690,
	'10.5': 89500,
	'11.0': 104070,
	'11.5': 106870,
	'12.0': 109670,
	'12.5': 112460,
	'13.0': 115260,
	'13.5': 118060,
	'14.0': 120860,
	'14.5': 123650,
	'15.0': 126450,
	'15.5': 129250,
	'16.0': 132050,
	'16.5': 150470,
	'17.0': 153600,
	'17.5': 156720,
	'18.0': 159840,
	'18.5': 162960,
	'19.0': 166080,
	'19.5': 169200,
	'20.0': 172330,
	'20.5': 175450,
	'21.0': 216910,
	'21.5': 222390,
	'22.0': 227870,
	'22.5': 233360,
	'23.0': 238840,
	'23.5': 244320,
	'24.0': 249800,
	'24.5': 255290,
	'25.0': 260770,
	'25.5': 266250,
	'26.0': 271740,
	'26.5': 277220,
	'27.0': 282700,
	'27.5': 288180,
	'28.0': 293670,
	'28.5': 299150,
	'29.0': 304630,
	'29.5': 310110,
	'30.0': 315600,
	'30.5': 321080,
	'31.0': 326560,
	'31.5': 332050,
	'32.0': 337530,
	'32.5': 343010,
}

const zoneG = {
	'0.5': 22010,
	'1.0': 25380,
	'1.5': 28760,
	'2.0': 32260,
	'2.5': 35660,
	'3.0': 39610,
	'3.5': 42820,
	'4.0': 46020,
	'4.5': 49230,
	'5.0': 52430,
	'5.5': 57780,
	'6.0': 60900,
	'6.5': 64030,
	'7.0': 67150,
	'7.5': 70270,
	'8.0': 73390,
	'8.5': 76520,
	'9.0': 85290,
	'9.5': 88630,
	'10.0': 91970,
	'10.5': 94800,
	'11.0': 106120,
	'11.5': 109740,
	'12.0': 113350,
	'12.5': 116970,
	'13.0': 120590,
	'13.5': 124210,
	'14.0': 127830,
	'14.5': 131450,
	'15.0': 135060,
	'15.5': 138680,
	'16.0': 142300,
	'16.5': 154460,
	'17.0': 158290,
	'17.5': 162120,
	'18.0': 165950,
	'18.5': 169780,
	'19.0': 173610,
	'19.5': 177440,
	'20.0': 181270,
	'20.5': 185100,
	'21.0': 248310,
	'21.5': 254710,
	'22.0': 261110,
	'22.5': 267510,
	'23.0': 273910,
	'23.5': 280300,
	'24.0': 286700,
	'24.5': 293100,
	'25.0': 299500,
	'25.5': 305900,
	'26.0': 312300,
	'26.5': 318700,
	'27.0': 325100,
	'27.5': 331500,
	'28.0': 337900,
	'28.5': 344300,
	'29.0': 350700,
	'29.5': 357100,
	'30.0': 363500,
	'30.5': 369900,
	'31.0': 376300,
	'31.5': 382690,
	'32.0': 389090,
	'32.5': 395490,
}

const zoneH = {
	'0.5': 23540,
	'1.0': 27780,
	'1.5': 32050,
	'2.0': 36520,
	'2.5': 40860,
	'3.0': 45260,
	'3.5': 49380,
	'4.0': 53500,
	'4.5': 57620,
	'5.0': 61730,
	'5.5': 68130,
	'6.0': 72050,
	'6.5': 75980,
	'7.0': 79900,
	'7.5': 83820,
	'8.0': 87750,
	'8.5': 91670,
	'9.0': 103040,
	'9.5': 107270,
	'10.0': 111500,
	'10.5': 114810,
	'11.0': 129360,
	'11.5': 133640,
	'12.0': 137920,
	'12.5': 142200,
	'13.0': 146480,
	'13.5': 150750,
	'14.0': 155030,
	'14.5': 159310,
	'15.0': 163590,
	'15.5': 167870,
	'16.0': 172150,
	'16.5': 188420,
	'17.0': 192990,
	'17.5': 197560,
	'18.0': 202130,
	'18.5': 206700,
	'19.0': 211270,
	'19.5': 215840,
	'20.0': 220410,
	'20.5': 224980,
	'21.0': 283360,
	'21.5': 290740,
	'22.0': 298120,
	'22.5': 305500,
	'23.0': 312890,
	'23.5': 320270,
	'24.0': 327650,
	'24.5': 335030,
	'25.0': 342410,
	'25.5': 349790,
	'26.0': 357180,
	'26.5': 364560,
	'27.0': 371940,
	'27.5': 379320,
	'28.0': 386700,
	'28.5': 394090,
	'29.0': 401470,
	'29.5': 408850,
	'30.0': 416230,
	'30.5': 423610,
	'31.0': 430990,
	'31.5': 438380,
	'32.0': 445760,
	'32.5': 453140,
}

const zoneI = {
	'0.5': 35380,
	'1.0': 42340,
	'1.5': 50530,
	'2.0': 56260,
	'2.5': 61750,
	'3.0': 69460,
	'3.5': 76500,
	'4.0': 83540,
	'4.5': 90580,
	'5.0': 97620,
	'5.5': 112860,
	'6.0': 119920,
	'6.5': 126980,
	'7.0': 134030,
	'7.5': 141090,
	'8.0': 148150,
	'8.5': 155210,
	'9.0': 176300,
	'9.5': 183960,
	'10.0': 191630,
	'10.5': 196450,
	'11.0': 250570,
	'11.5': 258530,
	'12.0': 266480,
	'12.5': 274430,
	'13.0': 282390,
	'13.5': 290340,
	'14.0': 298290,
	'14.5': 306240,
	'15.0': 314200,
	'15.5': 322150,
	'16.0': 330100,
	'16.5': 330150,
	'17.0': 337920,
	'17.5': 345690,
	'18.0': 353450,
	'18.5': 361220,
	'19.0': 368990,
	'19.5': 376750,
	'20.0': 384520,
	'20.5': 392290,
	'21.0': 399380,
	'21.5': 409780,
	'22.0': 420180,
	'22.5': 430570,
	'23.0': 440970,
	'23.5': 451370,
	'24.0': 461770,
	'24.5': 472170,
	'25.0': 482570,
	'25.5': 492970,
	'26.0': 503370,
	'26.5': 513770,
	'27.0': 524160,
	'27.5': 534560,
	'28.0': 544960,
	'28.5': 555360,
	'29.0': 565760,
	'29.5': 576160,
	'30.0': 586560,
	'30.5': 596960,
	'31.0': 607360,
	'31.5': 617750,
	'32.0': 628150,
	'32.5': 638550,
}

const zoneJ = {
	'0.5': 23700,
	'1.0': 29560,
	'1.5': 34760,
	'2.0': 38570,
	'2.5': 42220,
	'3.0': 42990,
	'3.5': 47340,
	'4.0': 51690,
	'4.5': 56040,
	'5.0': 60390,
	'5.5': 69750,
	'6.0': 74080,
	'6.5': 78420,
	'7.0': 82750,
	'7.5': 87090,
	'8.0': 91430,
	'8.5': 95760,
	'9.0': 108940,
	'9.5': 113660,
	'10.0': 118380,
	'10.5': 121220,
	'11.0': 134450,
	'11.5': 138800,
	'12.0': 143150,
	'12.5': 147490,
	'13.0': 151840,
	'13.5': 156190,
	'14.0': 160530,
	'14.5': 164880,
	'15.0': 169230,
	'15.5': 173580,
	'16.0': 177920,
	'16.5': 177980,
	'17.0': 182220,
	'17.5': 186470,
	'18.0': 190710,
	'18.5': 194960,
	'19.0': 199200,
	'19.5': 203450,
	'20.0': 207690,
	'20.5': 211930,
	'21.0': 244920,
	'21.5': 251300,
	'22.0': 257680,
	'22.5': 264060,
	'23.0': 270430,
	'23.5': 276810,
	'24.0': 283190,
	'24.5': 289570,
	'25.0': 295950,
	'25.5': 302320,
	'26.0': 308700,
	'26.5': 315080,
	'27.0': 321460,
	'27.5': 327840,
	'28.0': 334210,
	'28.5': 340590,
	'29.0': 346970,
	'29.5': 353350,
	'30.0': 359720,
	'30.5': 366100,
	'31.0': 372480,
	'31.5': 378860,
	'32.0': 385240,
	'32.5': 391610,
}

const zoneK = {
	'0.5': 21020,
	'1.0': 22180,
	'1.5': 23070,
	'2.0': 24500,
	'2.5': 25920,
	'3.0': 27240,
	'3.5': 28560,
	'4.0': 29890,
	'4.5': 31210,
	'5.0': 32530,
	'5.5': 32630,
	'6.0': 33700,
	'6.5': 34760,
	'7.0': 35830,
	'7.5': 36900,
	'8.0': 37960,
	'8.5': 39030,
	'9.0': 40090,
	'9.5': 41160,
	'10.0': 42220,
	'10.5': 65180,
	'11.0': 66700,
	'11.5': 68220,
	'12.0': 69730,
	'12.5': 71250,
	'13.0': 72770,
	'13.5': 74290,
	'14.0': 75800,
	'14.5': 77320,
	'15.0': 78840,
	'15.5': 80350,
	'16.0': 81870,
	'16.5': 83390,
	'17.0': 84910,
	'17.5': 86420,
	'18.0': 87940,
	'18.5': 89460,
	'19.0': 90980,
	'19.5': 92490,
	'20.0': 94010,
	'20.5': 95530,
	'21.0': 106730,
	'21.5': 109410,
	'22.0': 112100,
	'22.5': 114790,
	'23.0': 117480,
	'23.5': 120170,
	'24.0': 122860,
	'24.5': 125550,
	'25.0': 128240,
	'25.5': 130930,
	'26.0': 133620,
	'26.5': 136310,
	'27.0': 139000,
	'27.5': 141690,
	'28.0': 144370,
	'28.5': 147060,
	'29.0': 149750,
	'29.5': 152440,
	'30.0': 155130,
	'30.5': 157820,
	'31.0': 160510,
	'31.5': 163200,
	'32.0': 165890,
	'32.5': 168580,
}

const zoneM = {
	'0.5': 19590,
	'1.0': 22380,
	'1.5': 25750,
	'2.0': 28880,
	'2.5': 31920,
	'3.0': 34610,
	'3.5': 37410,
	'4.0': 40210,
	'4.5': 43010,
	'5.0': 45810,
	'5.5': 52320,
	'6.0': 55150,
	'6.5': 57970,
	'7.0': 60800,
	'7.5': 63630,
	'8.0': 66460,
	'8.5': 69280,
	'9.0': 78720,
	'9.5': 81810,
	'10.0': 84890,
	'10.5': 87550,
	'11.0': 97920,
	'11.5': 101250,
	'12.0': 104590,
	'12.5': 107930,
	'13.0': 111270,
	'13.5': 114610,
	'14.0': 117950,
	'14.5': 121290,
	'15.0': 124620,
	'15.5': 127960,
	'16.0': 131300,
	'16.5': 142610,
	'17.0': 146140,
	'17.5': 149680,
	'18.0': 153210,
	'18.5': 156750,
	'19.0': 160290,
	'19.5': 163820,
	'20.0': 167360,
	'20.5': 170890,
	'21.0': 223700,
	'21.5': 229460,
	'22.0': 235230,
	'22.5': 240990,
	'23.0': 246760,
	'23.5': 252520,
	'24.0': 258290,
	'24.5': 264050,
	'25.0': 269820,
	'25.5': 275580,
	'26.0': 281350,
	'26.5': 287110,
	'27.0': 292880,
	'27.5': 298640,
	'28.0': 304410,
	'28.5': 310170,
	'29.0': 315940,
	'29.5': 321700,
	'30.0': 327470,
	'30.5': 333230,
	'31.0': 339000,
	'31.5': 344760,
	'32.0': 350530,
	'32.5': 356290,
}

const zoneN = {
	'0.5': 16400,
	'1.0': 17500,
	'1.5': 17990,
	'2.0': 19200,
	'2.5': 20420,
	'3.0': 21650,
	'3.5': 22880,
	'4.0': 24120,
	'4.5': 25350,
	'5.0': 26590,
	'5.5': 32220,
	'6.0': 33350,
	'6.5': 34480,
	'7.0': 35610,
	'7.5': 36750,
	'8.0': 37880,
	'8.5': 39010,
	'9.0': 40140,
	'9.5': 41270,
	'10.0': 42400,
	'10.5': 59690,
	'11.0': 61710,
	'11.5': 63720,
	'12.0': 65730,
	'12.5': 67740,
	'13.0': 69750,
	'13.5': 71760,
	'14.0': 73770,
	'14.5': 75780,
	'15.0': 77790,
	'15.5': 79810,
	'16.0': 81820,
	'16.5': 83830,
	'17.0': 85840,
	'17.5': 87850,
	'18.0': 89860,
	'18.5': 91870,
	'19.0': 93880,
	'19.5': 95890,
	'20.0': 97910,
	'20.5': 99920,
	'21.0': 149500,
	'21.5': 153260,
	'22.0': 157020,
	'22.5': 160780,
	'23.0': 164540,
	'23.5': 168310,
	'24.0': 172070,
	'24.5': 175830,
	'25.0': 179590,
	'25.5': 183350,
	'26.0': 187110,
	'26.5': 190870,
	'27.0': 194640,
	'27.5': 198400,
	'28.0': 202160,
	'28.5': 205920,
	'29.0': 209680,
	'29.5': 213440,
	'30.0': 217210,
	'30.5': 220970,
	'31.0': 224730,
	'31.5': 228490,
	'32.0': 232250,
	'32.5': 236010,
}

const zoneO = {
	'0.5': 18930,
	'1.0': 25210,
	'1.5': 29170,
	'2.0': 32020,
	'2.5': 34800,
	'3.0': 41650,
	'3.5': 44690,
	'4.0': 47730,
	'4.5': 50760,
	'5.0': 53800,
	'5.5': 55120,
	'6.0': 57570,
	'6.5': 60020,
	'7.0': 62470,
	'7.5': 64920,
	'8.0': 67370,
	'8.5': 69820,
	'9.0': 72000,
	'9.5': 74440,
	'10.0': 76880,
	'10.5': 78360,
	'11.0': 81040,
	'11.5': 82920,
	'12.0': 84800,
	'12.5': 86680,
	'13.0': 88560,
	'13.5': 90440,
	'14.0': 92330,
	'14.5': 94210,
	'15.0': 96090,
	'15.5': 97970,
	'16.0': 99850,
	'16.5': 109940,
	'17.0': 111970,
	'17.5': 114000,
	'18.0': 116040,
	'18.5': 118070,
	'19.0': 120100,
	'19.5': 122140,
	'20.0': 124170,
	'20.5': 126200,
	'21.0': 179250,
	'21.5': 183820,
	'22.0': 188380,
	'22.5': 192940,
	'23.0': 197500,
	'23.5': 202060,
	'24.0': 206620,
	'24.5': 211180,
	'25.0': 215740,
	'25.5': 220300,
	'26.0': 224860,
	'26.5': 229420,
	'27.0': 233980,
	'27.5': 238540,
	'28.0': 243100,
	'28.5': 247660,
	'29.0': 252220,
	'29.5': 256790,
	'30.0': 261350,
	'30.5': 265910,
	'31.0': 270470,
	'31.5': 275030,
	'32.0': 279590,
	'32.5': 284150,
}

const zoneP = {
	'0.5': 19320,
	'1.0': 20500,
	'1.5': 21580,
	'2.0': 23040,
	'2.5': 24460,
	'3.0': 25890,
	'3.5': 27320,
	'4.0': 28750,
	'4.5': 30180,
	'5.0': 31610,
	'5.5': 37140,
	'6.0': 38440,
	'6.5': 39740,
	'7.0': 41040,
	'7.5': 42340,
	'8.0': 43650,
	'8.5': 44950,
	'9.0': 46250,
	'9.5': 47550,
	'10.0': 48850,
	'10.5': 90750,
	'11.0': 92710,
	'11.5': 94680,
	'12.0': 96640,
	'12.5': 98610,
	'13.0': 100570,
	'13.5': 102540,
	'14.0': 104500,
	'14.5': 106470,
	'15.0': 108440,
	'15.5': 110400,
	'16.0': 112370,
	'16.5': 114330,
	'17.0': 116300,
	'17.5': 118260,
	'18.0': 120230,
	'18.5': 122190,
	'19.0': 124160,
	'19.5': 126130,
	'20.0': 128090,
	'20.5': 130060,
	'21.0': 130000,
	'21.5': 133290,
	'22.0': 136590,
	'22.5': 139890,
	'23.0': 143190,
	'23.5': 146490,
	'24.0': 149780,
	'24.5': 153080,
	'25.0': 156380,
	'25.5': 159680,
	'26.0': 162970,
	'26.5': 166270,
	'27.0': 169570,
	'27.5': 172870,
	'28.0': 176170,
	'28.5': 179460,
	'29.0': 182760,
	'29.5': 186060,
	'30.0': 189360,
	'30.5': 192650,
	'31.0': 195950,
	'31.5': 199250,
	'32.0': 202550,
	'32.5': 205850,
}

const zoneQ = {
	'0.5': 17080,
	'1.0': 19510,
	'1.5': 21470,
	'2.0': 22900,
	'2.5': 24360,
	'3.0': 25830,
	'3.5': 27300,
	'4.0': 28770,
	'4.5': 30250,
	'5.0': 31720,
	'5.5': 36000,
	'6.0': 37270,
	'6.5': 38530,
	'7.0': 39790,
	'7.5': 41060,
	'8.0': 42320,
	'8.5': 43580,
	'9.0': 44840,
	'9.5': 46110,
	'10.0': 47370,
	'10.5': 64080,
	'11.0': 66240,
	'11.5': 68400,
	'12.0': 70560,
	'12.5': 72720,
	'13.0': 74880,
	'13.5': 77040,
	'14.0': 79200,
	'14.5': 81360,
	'15.0': 83520,
	'15.5': 85670,
	'16.0': 87830,
	'16.5': 89990,
	'17.0': 92150,
	'17.5': 94310,
	'18.0': 96470,
	'18.5': 98630,
	'19.0': 100790,
	'19.5': 102950,
	'20.0': 105110,
	'20.5': 107260,
	'21.0': 107520,
	'21.5': 110230,
	'22.0': 112930,
	'22.5': 115640,
	'23.0': 118340,
	'23.5': 121050,
	'24.0': 123750,
	'24.5': 126460,
	'25.0': 129160,
	'25.5': 131870,
	'26.0': 134570,
	'26.5': 137280,
	'27.0': 139980,
	'27.5': 142690,
	'28.0': 145400,
	'28.5': 148100,
	'29.0': 150810,
	'29.5': 153510,
	'30.0': 156220,
	'30.5': 158920,
	'31.0': 161630,
	'31.5': 164330,
	'32.0': 167040,
	'32.5': 169740,
}

const zoneR = {
	'0.5': 16860,
	'1.0': 19040,
	'1.5': 19760,
	'2.0': 21080,
	'2.5': 22420,
	'3.0': 23780,
	'3.5': 25130,
	'4.0': 26490,
	'4.5': 27840,
	'5.0': 29200,
	'5.5': 37800,
	'6.0': 39130,
	'6.5': 40450,
	'7.0': 41780,
	'7.5': 43110,
	'8.0': 44430,
	'8.5': 45760,
	'9.0': 47080,
	'9.5': 48410,
	'10.0': 49740,
	'10.5': 79370,
	'11.0': 82050,
	'11.5': 84720,
	'12.0': 87400,
	'12.5': 90070,
	'13.0': 92740,
	'13.5': 95420,
	'14.0': 98090,
	'14.5': 100770,
	'15.0': 103440,
	'15.5': 106110,
	'16.0': 108790,
	'16.5': 111460,
	'17.0': 114140,
	'17.5': 116810,
	'18.0': 119490,
	'18.5': 122160,
	'19.0': 124830,
	'19.5': 127510,
	'20.0': 130180,
	'20.5': 132860,
	'21.0': 141350,
	'21.5': 144910,
	'22.0': 148470,
	'22.5': 152020,
	'23.0': 155580,
	'23.5': 159140,
	'24.0': 162690,
	'24.5': 166250,
	'25.0': 169810,
	'25.5': 173360,
	'26.0': 176920,
	'26.5': 180480,
	'27.0': 184030,
	'27.5': 187590,
	'28.0': 191150,
	'28.5': 194700,
	'29.0': 198260,
	'29.5': 201820,
	'30.0': 205370,
	'30.5': 208930,
	'31.0': 212490,
	'31.5': 216040,
	'32.0': 219600,
	'32.5': 223160,
}

const zoneS = {
	'0.5': 18250,
	'1.0': 19970,
	'1.5': 21330,
	'2.0': 22760,
	'2.5': 24210,
	'3.0': 25670,
	'3.5': 27130,
	'4.0': 28600,
	'4.5': 30060,
	'5.0': 31520,
	'5.5': 33710,
	'6.0': 34890,
	'6.5': 36070,
	'7.0': 37250,
	'7.5': 38440,
	'8.0': 39620,
	'8.5': 40800,
	'9.0': 41980,
	'9.5': 43160,
	'10.0': 44350,
	'10.5': 60400,
	'11.0': 62440,
	'11.5': 64470,
	'12.0': 66510,
	'12.5': 68540,
	'13.0': 70580,
	'13.5': 72610,
	'14.0': 74640,
	'14.5': 76680,
	'15.0': 78710,
	'15.5': 80750,
	'16.0': 82780,
	'16.5': 84820,
	'17.0': 86850,
	'17.5': 88890,
	'18.0': 90920,
	'18.5': 92960,
	'19.0': 94990,
	'19.5': 97030,
	'20.0': 99060,
	'20.5': 101100,
	'21.0': 132600,
	'21.5': 135940,
	'22.0': 139280,
	'22.5': 142610,
	'23.0': 145950,
	'23.5': 149280,
	'24.0': 152620,
	'24.5': 155960,
	'25.0': 159290,
	'25.5': 162630,
	'26.0': 165970,
	'26.5': 169300,
	'27.0': 172640,
	'27.5': 175980,
	'28.0': 179310,
	'28.5': 182650,
	'29.0': 185990,
	'29.5': 189320,
	'30.0': 192660,
	'30.5': 196000,
	'31.0': 199330,
	'31.5': 202670,
	'32.0': 206010,
	'32.5': 209340,
}

const zoneT = {
	'0.5': 27230,
	'1.0': 29430,
	'1.5': 32610,
	'2.0': 34790,
	'2.5': 37000,
	'3.0': 39240,
	'3.5': 41480,
	'4.0': 43710,
	'4.5': 45950,
	'5.0': 48190,
	'5.5': 48550,
	'6.0': 50250,
	'6.5': 51950,
	'7.0': 53660,
	'7.5': 55360,
	'8.0': 57060,
	'8.5': 58770,
	'9.0': 60470,
	'9.5': 62170,
	'10.0': 63880,
	'10.5': 78210,
	'11.0': 80850,
	'11.5': 83480,
	'12.0': 86120,
	'12.5': 88750,
	'13.0': 91390,
	'13.5': 94020,
	'14.0': 96660,
	'14.5': 99290,
	'15.0': 101930,
	'15.5': 104560,
	'16.0': 107200,
	'16.5': 109830,
	'17.0': 112470,
	'17.5': 115100,
	'18.0': 117740,
	'18.5': 120370,
	'19.0': 123010,
	'19.5': 125640,
	'20.0': 128280,
	'20.5': 130910,
	'21.0': 181940,
	'21.5': 186520,
	'22.0': 191100,
	'22.5': 195680,
	'23.0': 200260,
	'23.5': 204830,
	'24.0': 209410,
	'24.5': 213990,
	'25.0': 218570,
	'25.5': 223150,
	'26.0': 227720,
	'26.5': 232300,
	'27.0': 236880,
	'27.5': 241460,
	'28.0': 246040,
	'28.5': 250610,
	'29.0': 255190,
	'29.5': 259770,
	'30.0': 264350,
	'30.5': 268930,
	'31.0': 273500,
	'31.5': 278080,
	'32.0': 282660,
	'32.5': 287240,
}

const zoneU = {
	'0.5': 23860,
	'1.0': 26950,
	'1.5': 26970,
	'2.0': 29150,
	'2.5': 31220,
	'3.0': 34020,
	'3.5': 36830,
	'4.0': 39630,
	'4.5': 42440,
	'5.0': 45240,
	'5.5': 53970,
	'6.0': 56810,
	'6.5': 59640,
	'7.0': 62480,
	'7.5': 65310,
	'8.0': 68140,
	'8.5': 70980,
	'9.0': 73810,
	'9.5': 76650,
	'10.0': 79480,
	'10.5': 130710,
	'11.0': 134320,
	'11.5': 137930,
	'12.0': 141540,
	'12.5': 145150,
	'13.0': 148760,
	'13.5': 152370,
	'14.0': 155980,
	'14.5': 159590,
	'15.0': 163200,
	'15.5': 166810,
	'16.0': 170430,
	'16.5': 174040,
	'17.0': 177650,
	'17.5': 181260,
	'18.0': 184870,
	'18.5': 188480,
	'19.0': 192090,
	'19.5': 195700,
	'20.0': 199310,
	'20.5': 202920,
	'21.0': 203740,
	'21.5': 208890,
	'22.0': 214040,
	'22.5': 219190,
	'23.0': 224340,
	'23.5': 229490,
	'24.0': 234640,
	'24.5': 239790,
	'25.0': 244940,
	'25.5': 250090,
	'26.0': 255240,
	'26.5': 260390,
	'27.0': 265540,
	'27.5': 270690,
	'28.0': 275840,
	'28.5': 280990,
	'29.0': 286140,
	'29.5': 291280,
	'30.0': 296430,
	'30.5': 301580,
	'31.0': 306730,
	'31.5': 311880,
	'32.0': 317030,
	'32.5': 322180,
}

const zoneV = {
	'0.5': 16270,
	'1.0': 18650,
	'1.5': 19810,
	'2.0': 21030,
	'2.5': 22250,
	'3.0': 23380,
	'3.5': 24520,
	'4.0': 25650,
	'4.5': 26790,
	'5.0': 27920,
	'5.5': 29640,
	'6.0': 30610,
	'6.5': 31580,
	'7.0': 32540,
	'7.5': 33510,
	'8.0': 34480,
	'8.5': 35450,
	'9.0': 36410,
	'9.5': 37380,
	'10.0': 38350,
	'10.5': 60120,
	'11.0': 61520,
	'11.5': 62920,
	'12.0': 64320,
	'12.5': 65720,
	'13.0': 67120,
	'13.5': 68520,
	'14.0': 69920,
	'14.5': 71320,
	'15.0': 72720,
	'15.5': 74120,
	'16.0': 75510,
	'16.5': 76910,
	'17.0': 78310,
	'17.5': 79710,
	'18.0': 81110,
	'18.5': 82510,
	'19.0': 83910,
	'19.5': 85310,
	'20.0': 86710,
	'20.5': 88110,
	'21.0': 98850,
	'21.5': 101340,
	'22.0': 103830,
	'22.5': 106330,
	'23.0': 108820,
	'23.5': 111310,
	'24.0': 113800,
	'24.5': 116290,
	'25.0': 118780,
	'25.5': 121270,
	'26.0': 123760,
	'26.5': 126250,
	'27.0': 128740,
	'27.5': 131230,
	'28.0': 133720,
	'28.5': 136220,
	'29.0': 138710,
	'29.5': 141200,
	'30.0': 143690,
	'30.5': 146180,
	'31.0': 148670,
	'31.5': 151160,
	'32.0': 153650,
	'32.5': 156140,
}
const zoneW = {
	'0.5': 21020,
	'1.0': 22150,
	'1.5': 23090,
	'2.0': 24630,
	'2.5': 26200,
	'3.0': 27780,
	'3.5': 29360,
	'4.0': 30950,
	'4.5': 32530,
	'5.0': 34120,
	'5.5': 34220,
	'6.0': 35430,
	'6.5': 36630,
	'7.0': 37830,
	'7.5': 39030,
	'8.0': 40230,
	'8.5': 41430,
	'9.0': 42630,
	'9.5': 43830,
	'10.0': 45030,
	'10.5': 64590,
	'11.0': 66760,
	'11.5': 68940,
	'12.0': 71120,
	'12.5': 73290,
	'13.0': 75470,
	'13.5': 77640,
	'14.0': 79820,
	'14.5': 82000,
	'15.0': 84170,
	'15.5': 86350,
	'16.0': 88520,
	'16.5': 90700,
	'17.0': 92880,
	'17.5': 95050,
	'18.0': 97230,
	'18.5': 99400,
	'19.0': 101580,
	'19.5': 103760,
	'20.0': 105930,
	'20.5': 108110,
	'21.0': 141050,
	'21.5': 144600,
	'22.0': 148150,
	'22.5': 151700,
	'23.0': 155250,
	'23.5': 158800,
	'24.0': 162340,
	'24.5': 165890,
	'25.0': 169440,
	'25.5': 172990,
	'26.0': 176540,
	'26.5': 180090,
	'27.0': 183640,
	'27.5': 187190,
	'28.0': 190740,
	'28.5': 194290,
	'29.0': 197830,
	'29.5': 201380,
	'30.0': 204930,
	'30.5': 208480,
	'31.0': 212030,
	'31.5': 215580,
	'32.0': 219130,
	'32.5': 222680,
}

const zoneX = {
	'0.5': 18180,
	'1.0': 19190,
	'1.5': 20090,
	'2.0': 21330,
	'2.5': 22570,
	'3.0': 23720,
	'3.5': 24870,
	'4.0': 26020,
	'4.5': 27170,
	'5.0': 28320,
	'5.5': 32650,
	'6.0': 33720,
	'6.5': 34780,
	'7.0': 35850,
	'7.5': 36910,
	'8.0': 37980,
	'8.5': 39050,
	'9.0': 40110,
	'9.5': 41180,
	'10.0': 42240,
	'10.5': 69080,
	'11.0': 70690,
	'11.5': 72300,
	'12.0': 73910,
	'12.5': 75510,
	'13.0': 77120,
	'13.5': 78730,
	'14.0': 80340,
	'14.5': 81950,
	'15.0': 83550,
	'15.5': 85160,
	'16.0': 86770,
	'16.5': 88380,
	'17.0': 89990,
	'17.5': 91590,
	'18.0': 93200,
	'18.5': 94810,
	'19.0': 96420,
	'19.5': 98030,
	'20.0': 99630,
	'20.5': 101240,
	'21.0': 133080,
	'21.5': 136430,
	'22.0': 139780,
	'22.5': 143140,
	'23.0': 146490,
	'23.5': 149840,
	'24.0': 153200,
	'24.5': 156550,
	'25.0': 159900,
	'25.5': 163260,
	'26.0': 166610,
	'26.5': 169960,
	'27.0': 173320,
	'27.5': 176670,
	'28.0': 180020,
	'28.5': 183380,
	'29.0': 186730,
	'29.5': 190080,
	'30.0': 193440,
	'30.5': 196790,
	'31.0': 200140,
	'31.5': 203490,
	'32.0': 206850,
	'32.5': 210200,
}

const zoneY = {
	'0.5': 14160,
	'1.0': 15340,
	'1.5': 17490,
	'2.0': 18570,
	'2.5': 19650,
	'3.0': 20650,
	'3.5': 21650,
	'4.0': 22650,
	'4.5': 23650,
	'5.0': 24660,
	'5.5': 26680,
	'6.0': 27550,
	'6.5': 28420,
	'7.0': 29290,
	'7.5': 30160,
	'8.0': 31030,
	'8.5': 31910,
	'9.0': 32780,
	'9.5': 33650,
	'10.0': 34520,
	'10.5': 58630,
	'11.0': 60000,
	'11.5': 61360,
	'12.0': 62730,
	'12.5': 64090,
	'13.0': 65450,
	'13.5': 66820,
	'14.0': 68180,
	'14.5': 69550,
	'15.0': 70910,
	'15.5': 72280,
	'16.0': 73640,
	'16.5': 75010,
	'17.0': 76370,
	'17.5': 77740,
	'18.0': 79100,
	'18.5': 80470,
	'19.0': 81830,
	'19.5': 83200,
	'20.0': 84560,
	'20.5': 85930,
	'21.0': 86400,
	'21.5': 88580,
	'22.0': 90760,
	'22.5': 92930,
	'23.0': 95110,
	'23.5': 97290,
	'24.0': 99460,
	'24.5': 101640,
	'25.0': 103820,
	'25.5': 106000,
	'26.0': 108170,
	'26.5': 110350,
	'27.0': 112530,
	'27.5': 114700,
	'28.0': 116880,
	'28.5': 119060,
	'29.0': 121240,
	'29.5': 123410,
	'30.0': 125590,
	'30.5': 127770,
	'31.0': 129940,
	'31.5': 132120,
	'32.0': 134300,
	'32.5': 136470,
}

export const ficpRates = {
	A: zoneA,
	D: zoneD,
	E: zoneE,
	F: zoneF,
	G: zoneG,
	H: zoneH,
	I: zoneI,
	J: zoneJ,
	K: zoneK,
	M: zoneM,
	N: zoneN,
	O: zoneO,
	P: zoneP,
	Q: zoneQ,
	R: zoneR,
	S: zoneS,
	T: zoneT,
	U: zoneU,
	V: zoneV,
	W: zoneW,
	X: zoneX,
	Y: zoneY,
}
